var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 315.743,
    height: 225.139,
    viewBox: "0 0 315.743 225.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_686",
    x: 34.812,
    y: 50.949,
    width: 186.324,
    height: 138.163,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_690",
    x: 6.131,
    y: 0,
    width: 155.182,
    height: 122.591,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_700",
    x: 150.463,
    y: 98,
    width: 165.28,
    height: 127.139,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(-1.11 8.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    d: "M10,0H63.155a0,0,0,0,1,0,0V31.577a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(1.11 44.661)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 44.661)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 44.661)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    d: "M0,0H53.155a10,10,0,0,1,10,10V31.577a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(190.573 44.661)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    d: "M0,0H53.155a10,10,0,0,1,10,10V31.577a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(190.573 44.661)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 63.155,
    height: 31.577,
    transform: "translate(1.11 76.238)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 63.155,
    height: 31.577,
    transform: "translate(64.265 76.238)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 63.155,
    height: 31.577,
    transform: "translate(64.265 76.238)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 76.238)",
    fill: "#fce8b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 76.238)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 63.155,
    height: 31.577,
    transform: "translate(190.573 76.238)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 63.155,
    height: 31.577,
    transform: "translate(190.573 76.238)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 63.155,
    height: 31.577,
    transform: "translate(1.11 107.816)",
    fill: "#ccf3d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 63.155,
    height: 31.577,
    transform: "translate(64.265 107.816)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 63.155,
    height: 31.577,
    transform: "translate(64.265 107.816)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 107.816)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 107.816)",
    fill: "none",
    stroke: "#f8f8f8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 63.155,
    height: 31.577,
    transform: "translate(190.573 107.816)",
    fill: "#fce8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    d: "M0,0H63.155a0,0,0,0,1,0,0V31.577a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(1.11 139.394)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 63.155,
    height: 31.577,
    transform: "translate(64.265 139.394)",
    fill: "#cef5d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 63.155,
    height: 31.577,
    transform: "translate(127.419 139.394)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.11, -8.2)",
    filter: "url(#Rectangle_686)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686-2",
    "data-name": "Rectangle 686",
    width: 96.324,
    height: 48.163,
    rx: 10,
    transform: "translate(79.81 92.95)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M132.207,99.47a14.612,14.612,0,1,1-14.612-14.612A14.612,14.612,0,0,1,132.207,99.47",
    transform: "translate(11.381 9.378)",
    fill: "#21d17f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y2: 19.401,
    transform: "translate(128.976 99.147)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 19.401,
    transform: "translate(119.276 108.848)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.11, -8.2)",
    filter: "url(#Rectangle_690)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690-2",
    "data-name": "Rectangle 690",
    width: 65.182,
    height: 32.591,
    rx: 5,
    transform: "translate(51.13 42)",
    fill: "#fce8b3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 28.683,
    height: 3.107,
    rx: 1.554,
    transform: "translate(123.217 37.202)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 20.557,
    height: 3.107,
    rx: 1.554,
    transform: "translate(123.217 41.505)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 20.557,
    height: 3.107,
    rx: 1.554,
    transform: "translate(123.217 46.189)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 28.683,
    height: 3.107,
    rx: 1.554,
    transform: "translate(158.996 139.827)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 20.557,
    height: 3.107,
    rx: 1.554,
    transform: "translate(167.123 144.131)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 20.557,
    height: 3.107,
    rx: 1.554,
    transform: "translate(167.123 148.814)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.11, -8.2)",
    filter: "url(#Rectangle_700)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700-2",
    "data-name": "Rectangle 700",
    width: 75.28,
    height: 37.139,
    rx: 5,
    transform: "translate(195.46 140)",
    fill: "#cef5d9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.4754d8db3fabc7a66e8dcbda132716a0.svg";
export { ForwardRef as ReactComponent };